/*
  UserReport/ListComponent.js - Creates Table headers and populates body
*/

// NPM
import React, { useEffect, useState } from 'react';

// MUI COMPONENTS
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

// COMPONENTS
import Paginator from '../../common/Paginator';
import config from '../../../Config';
import MessagePartTooltip from '../../common/tooltips/MessagePartsTooltip';

// FORMATTED MESSAGES
import UserReportsFormattedMessages from '../../../messages/reports/ReportsFormattedMessages';

import {
  tableCellBorderRight,
  tableRowCellBorderRight,
} from '../../../styles/tables';

const UserReportsTable = ({ list, totals, filter }) => {
  const [pageLength, setPageLength] = useState(config.defaultPL);
  const [pageNumber, setPageNumber] = useState(1);
  const [displayList, setDisplayList] = useState([]);
  const [count, setCount] = useState(0);

  const changePageLength = (e) => {
    const value = e.target.value;
    setPageLength(value);
    setPageNumber(1);
  };

  const changeEvent = (i) => {
    setPageNumber(i);
  };

  const handleList = () => {
    if (list && Array.isArray(list)) {
      const displayList = list.slice(
        (pageNumber - 1) * pageLength,
        (pageNumber - 1) * pageLength + pageLength
      );
      setDisplayList(displayList);
      setCount(list.length);
    } else {
      setCount(0);
      setDisplayList([]);
    }
  };

  useEffect(() => {
    handleList();
  }, [pageLength, pageNumber]);

  useEffect(() => {
    setPageNumber(1);
    handleList();
  }, [list]);

  return (
    <React.Fragment>
      {filter()}
      <TableContainer
        sx={{
          marginBottom: 4,
          overflowX: 'auto',
          width: '100%',
          whiteSpace: 'nowrap',
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={tableCellBorderRight} colSpan={2}>
                {UserReportsFormattedMessages.customerUserText}
              </TableCell>
              <TableCell colSpan={4} sx={tableCellBorderRight} align="center">
                {UserReportsFormattedMessages.messagesText}
                <MessagePartTooltip />
              </TableCell>
              <TableCell align="center" sx={tableCellBorderRight} colSpan={2}>
                {UserReportsFormattedMessages.remindersText}
                <MessagePartTooltip />
              </TableCell>
              <TableCell align="right">
                {UserReportsFormattedMessages.callForwardingText}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left">
                {UserReportsFormattedMessages.nameText}
              </TableCell>
              <TableCell align="right" sx={tableCellBorderRight}>
                {UserReportsFormattedMessages.statusText}
              </TableCell>
              <TableCell align="right">
                {UserReportsFormattedMessages.directText}
              </TableCell>
              <TableCell align="right">
                {UserReportsFormattedMessages.standardText}
              </TableCell>
              <TableCell align="right">
                {UserReportsFormattedMessages.internationalText}
              </TableCell>
              <TableCell align="right" sx={tableCellBorderRight}>
                {UserReportsFormattedMessages.repliesText}
              </TableCell>
              <TableCell align="right">
                {UserReportsFormattedMessages.sentText}
              </TableCell>
              <TableCell align="right" sx={tableCellBorderRight}>
                {UserReportsFormattedMessages.pendingText}
              </TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayList}
            <TableRow>
              <TableCell align="left">
                {UserReportsFormattedMessages.totalText}
              </TableCell>
              <TableCell align="right" sx={tableRowCellBorderRight}></TableCell>
              <TableCell align="right">{`${totals.Direct} (${totals.DirectParts})`}</TableCell>
              <TableCell align="right">{`${totals.Standard} (${totals.StandardParts})`}</TableCell>
              <TableCell align="right">{`${totals.International} (${totals.InternationalParts})`}</TableCell>
              <TableCell
                align="right"
                sx={tableRowCellBorderRight}
              >{`${totals.Replies} (${totals.RepliesParts})`}</TableCell>
              <TableCell align="right">{`${totals.Sent} (${totals.SentParts})`}</TableCell>
              <TableCell
                align="right"
                sx={tableRowCellBorderRight}
              >{`${totals.Pending} (${totals.PendingParts})`}</TableCell>
              <TableCell align="right">{`${totals.Call} (${totals.CallMinutes})`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Paginator
        itemCount={count}
        pageNumber={pageNumber}
        pageLength={pageLength}
        editFunction={changePageLength}
        changeEvent={changeEvent}
      />
    </React.Fragment>
  );
};

export default UserReportsTable;
